import { useState } from 'react';
import type { FlightResearchOffersSelection } from '@voll-intelligence/genui-contract';
import type { GenUiDispatch } from '../../shared/ui/action.js';
import { useGenUiI18n } from '../../shared/ui/i18n.js';

/**
 * O "Buscar de novo" da faixa de opção expirada nos cards do chat
 * (`flight_offers`, `flight_multi_offers`) — #5277. É um turno da CONVERSA: o
 * gesto estruturado `research_offers` sai pelo `challengeId` do card, o agente
 * refaz a busca com os critérios em vigor e o card novo chega na thread. Abrir o
 * explorer em tela cheia (o que este CTA fazia) tirava a pessoa do chat.
 *
 * `researching` vale para o challenge do gesto: trava o CTA até o turno chegar,
 * e um card re-emitido com outro challenge (a busca nova) nasce destravado.
 * `onResearch` ausente ⇒ sem canal (card congelado): a faixa fica só com a copy.
 */
export function useResearchOffers({
  challengeId,
  dispatch,
  enabled,
}: {
  challengeId: string | undefined;
  dispatch: GenUiDispatch | undefined;
  enabled: boolean;
}): { onResearch?: () => void; researching: boolean } {
  const { t } = useGenUiI18n();
  const [sentFor, setSentFor] = useState<string | null>(null);
  const researching = challengeId !== undefined && sentFor === challengeId;
  if (!enabled || !challengeId || !dispatch) return { researching };
  return {
    researching,
    onResearch: () => {
      setSentFor(challengeId);
      const data: FlightResearchOffersSelection = { action: 'research_offers' };
      dispatch({
        type: 'interaction',
        interactionId: challengeId,
        text: t('flightOffers.searchAgainReply'),
        data,
      });
    },
  };
}
